module.exports = __webpack_public_path__ + "static/servico1-c13b9f6fd7c99ea62a4660ac3723d823.jpg";